import { ITransactionError } from '@contracts/types'

export const ERROR_DISMISS_TIMEOUT = 10000

export const getStringTxError = (error: ITransactionError['error']) =>
  typeof error === 'string'
    ? error
    : 'Transaction failed'
